import { render, staticRenderFns } from "./ClientContractSelect.vue?vue&type=template&id=6087bbcc&"
import script from "./ClientContractSelect.vue?vue&type=script&lang=js&"
export * from "./ClientContractSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports